import { BrowserRouter, Navigate, Route, Routes, useParams } from "react-router-dom"
import { AuthProvider } from "./auth/AuthProvider"
import { ProtectedRoute } from "./auth/ProtectedRoute"
import { LoginCallback } from "./pages/LoginCallback"
import { HomePage } from "./pages/HomePage"
import { ReceiptsPage } from "./pages/ReceiptsPage"
import { ReceiptDetailPage } from "./pages/ReceiptDetailPage"
import { TemplatesPage } from "./pages/TemplatesPage"
import { TemplateUploadPage } from "./pages/TemplateUploadPage"
import { FormViewerPage } from "./pages/FormViewerPage"
import { CellEditorPage } from "./pages/CellEditorPage"
import { SettingsPage } from "./pages/SettingsPage"

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/auth/callback" element={<LoginCallback />} />
          <Route path="/" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
          <Route path="/receipts" element={<ProtectedRoute><ReceiptsPage /></ProtectedRoute>} />
          <Route path="/receipts/:id" element={<ProtectedRoute><ReceiptDetailPage /></ProtectedRoute>} />
          <Route path="/templates" element={<ProtectedRoute><TemplatesPage /></ProtectedRoute>} />
          <Route path="/templates/new" element={<ProtectedRoute><TemplateUploadPage /></ProtectedRoute>} />
          <Route path="/forms/:templateId/:instanceKey" element={<ProtectedRoute><FormViewerPage /></ProtectedRoute>} />
          <Route path="/cells/:templateId/:instanceKey" element={<ProtectedRoute><CellEditorPage /></ProtectedRoute>} />
          <Route path="/cells/:templateId" element={<ProtectedRoute><CellEditorPage /></ProtectedRoute>} />
          <Route path="/diary/:week" element={<RedirectDiaryToForm />} />
          <Route path="/diary/:week/book" element={<RedirectDiaryBookToForm />} />
          <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}

function RedirectDiaryToForm() {
  const { week } = useParams<{ week: string }>()
  return <Navigate to={`/forms/istat-1559-2024/${encodeURIComponent(week ?? "")}`} replace />
}

function RedirectDiaryBookToForm() {
  const { week } = useParams<{ week: string }>()
  return <Navigate to={`/forms/istat-1559-2024/${encodeURIComponent(week ?? "")}`} replace />
}
